<flex-select-tree-input *ngIf="hasInitilized" #flexSelectTreeInput 
    [nodes]="queueNodes" 
    [placeholder]="placeholder" 
    [multiple]="multiple" 
    [showCheckAll]="showCheckAll" 
    [formControl]="myControl"></flex-select-tree-input>
